import { render, staticRenderFns } from "./NoticeCashIsaCloseAccount.vue?vue&type=template&id=90a493ec"
import script from "./NoticeCashIsaCloseAccount.vue?vue&type=script&lang=js"
export * from "./NoticeCashIsaCloseAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports